import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import { ObliqueTriangleVM } from './ObliqueTriangleVM';
import {
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  InputContainer,
  FormulaPrintModalContainer
} from '../template/FormulaFormTemplates';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const ObliqueTriangleComponent = (props) => {
  const vm = useRef(new ObliqueTriangleVM(props)).current;
  useEffect(() => {
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);

  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content">
        <InputContainer
          computeCallback={() => {
            vm.computeOTriangle();
          }}
          printCallback={() => {
            vm.launchAndExport();
          }}
          isLoading={vm.isLoading}
          disableCompute={vm.disableComputeBtn}
          disablePrint={vm.disablePrintBtn}
        >
          <h2 className='sections-heading'>General</h2>
          <Input
            label="Side 'a'"
            idAndName="side-a"
            aria-label="side a"
            valid={!vm.formValidation.sideA}
            value={vm.OTriangleFormData.sideA}
            type="number"
            onChange={(e) => {
              vm.handleInputOnChange(e);
            }}
            onKeyDown={vm.handleOnKeyDown}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.inputsFormClassName('sideA')}
            min={0.01}
          />
          <Input
            label="Side 'b'"
            idAndName="side-b"
            aria-label="side b"
            valid={!vm.formValidation.sideB}
            value={vm.OTriangleFormData.sideB}
            type="number"
            onChange={(e) => {
              vm.handleInputOnChange(e);
            }}
            onKeyDown={vm.handleOnKeyDown}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.inputsFormClassName('sideB')}
            min={0.01}
          />
          <Input
            label="Side 'c'"
            idAndName="side-c"
            aria-label="side c"
            valid={!vm.formValidation.sideC}
            value={vm.OTriangleFormData.sideC}
            type="number"
            onChange={(e) => {
              vm.handleInputOnChange(e);
            }}
            onKeyDown={vm.handleOnKeyDown}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.inputsFormClassName('sideC')}
            min={0.01}
          />
        </InputContainer>
        <div className="col formula-information ">
          {vm.hasResults ? (
            <div className="col formula-results">
              <ResultsContainer >
              <div className="col-auto ">
                  <div className="row">
                    <div className="col-auto result-label">Area (sq units):</div>
                    <div className="col-auto result-value">{vm.calculationResults.area}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Height (units):</div>
                    <div className="col-auto result-value">{vm.calculationResults.h}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Angle A&deg;:</div>
                    <div className="col-auto result-value">{vm.calculationResults.angleA}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Angle B&deg;:</div>
                    <div className="col-auto result-value">{vm.calculationResults.angleB}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label"> Angle C&deg;:</div>
                    <div className="col-auto result-value">{vm.calculationResults.angleC}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Radius (units):</div>
                    <div className="col-auto result-value">{vm.calculationResults.r}</div>
                  </div>
                    <div className="row">
                      <div className="col-auto result-label">Half of the Perimeter s (units):</div>
                      <div className="col-auto result-value">{vm.calculationResults.s}</div>
                    </div>
                </div>
              </ResultsContainer>
            </div>
          ) : (
            ''
          )}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>{vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              <img className="water-flow-img" src={vm.image} alt={vm.hydraulicFormulaImageDescription} title={vm.formulaTitle} />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  )
}

export const ObliqueTriangleFormula = observer(ObliqueTriangleComponent);